import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiSchema,ApiError ,NotFoundError} from "./ApiClient";
import { DocumentAutoGeneratedNumberFormData } from "@/formTypes/DocumentAutoGeneratedNumberDataType";
import { getTenantId } from "@utils/Auth";


export type DocumentAutoGeneratedNumberDataType = Partial<ApiSchema["DocumentAutoGeneratedNumber"]["type"] & DocumentAutoGeneratedNumberFormData>;

class Api extends GenericModelApi<"DocumentAutoGeneratedNumber", DocumentAutoGeneratedNumberDataType> {d

    async getAutoGeneratedNumberByModelName(modelName: string): Promise<DocumentAutoGeneratedNumberDataType> {
        const tenantId = await getTenantId();
        const fetchFunction = ApiClient.models[this.modelName].listDocumentAutoGeneratedNumberByTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            modelName: { eq: modelName },
        }, {
            limit: 1,
        });

        if (errors) {
            throw new ApiError("Error al obtener el GeneratedNumber", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0]
        }

        return {}
    }

}
export const DocumentAutoGeneratedNumberApi = new Api("DocumentAutoGeneratedNumber", "modelName")